























import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    PropType,
    onMounted,
    ref,
    watch,
} from '@vue/composition-api';
import Vue from 'vue';
import { useApolloModel } from 'vue-apollo-model';
import { DataCenterModel } from '../model';
import { BoardListType } from '../type';
import { getReportSeries, formatCount } from '../service';

export default defineComponent({
    props: {
        board: {
            type: Object as PropType<BoardListType>,
            required: true,
        },
        appId: {
            type: String,
            required: true,
        },
    },
    setup(props, context) {
        const model = useApolloModel(DataCenterModel);
        const count = ref({});

        async function refreshBoard() {
            const res = await getReportSeries({
                source: props.board.source,
                seriesName: props.board.seriesName,
                appId: props.appId,
            });
            const len = res.data?.length || 0;
            count.value = len
                ? formatCount(res.data[len - 1][props.board.seriesName])
                : { num: '0', unit: '' };
        }

        watch(
            () => props.appId,
            async (v) => {
                if (v) {
                    await refreshBoard();
                }
            },
            { immediate: true },
        );
        return {
            count,
        };
    },
});
